var map = {
	"./analytics.png": 39076,
	"./arrow.png": 9802,
	"./bazaarvoice.png": 19554,
	"./blueSignInBg.png": 85810,
	"./country/de.svg": 6393,
	"./country/en.svg": 19271,
	"./country/es.svg": 63348,
	"./country/fr.svg": 91826,
	"./country/us.svg": 86298,
	"./custom.png": 83441,
	"./findifyByMaropostLogo.png": 79627,
	"./instagram.png": 58099,
	"./lipscore.png": 2309,
	"./merch-cloud-maropost.png": 32073,
	"./merch-cloud.png": 20899,
	"./powerreviews.png": 81273,
	"./reviewsio.png": 78321,
	"./sample_one_way_synonyms.jpg": 39386,
	"./sample_two_way_synonyms.jpg": 56932,
	"./stamped.png": 47382,
	"./synonyms.png": 20910,
	"./yotpo.png": 19819
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80061;